exports.install = function(Vue,options){
  Vue.prototype.toastText = function(text,icon=true){
    this.$toast({
      message:text,
      icon:icon?require('@/assets/img/tipicon.png'):null
    });
  },
  Vue.prototype.toastSucc = function(text){
    this.$toast.success({
      message:text,
      icon:require('@/assets/img/succicon.png')
    })
  },
  Vue.prototype.toastFail = function(text){
    this.$toast.fail({
      message:text,
      icon:require('@/assets/img/fail.png')
    })
  },
  Vue.prototype.toastLoading = function(text,duration){
    this.$toast.loading({
      mask: true,
      message:text,
      duration:duration
    })
  },
  Vue.prototype.toastClose = function(){
    this.$toast.clear({
      
    })
  }
}